import { Box, Grid } from "@mui/material";
import Input from "../../../components/input/Input-v2";
import { SubmitHandler, useForm } from "react-hook-form";
import InputCategory from "./__components/InputCategory";
import InputBrand from "./__components/InputBrand";
import { LoadingButton } from "../../../components/button/Button";
import { useAddProduct } from "../api/product/resolver";

export type Form_Create_Product = {
  product_type_name: string;
  product_category_id: number;
  product_brand_id: number;
  unit_type: string;
  price: number | string;
  wholesale_price: number | string;
  buying_price: number | string;
  stock: number | string;
  has_tax: number | string;
  skip_stock: number;
};

interface FormCreate {
  onSubmit: (form: Form_Create_Product) => void;
}

export default function FormCreate() {
  const { mutate: mutateAddProduct, isLoading: loadingAddProduct } =
    useAddProduct();
  const { handleSubmit, control } = useForm<Form_Create_Product>({
    defaultValues: {
      product_type_name: "",
      unit_type: "",
      price: "",
      wholesale_price: "",
      buying_price: "",
      stock: "",
      has_tax: "",
    },
  });

  const handleFormSubmit: SubmitHandler<Form_Create_Product> = (data) => {
    mutateAddProduct({ ...data });
  };

  return (
    <Box p={1} pb={2} pt={2} bgcolor={"white"} borderRadius={2}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputCategory
              disabled={false}
              control={control}
              controlName="product_category_id"
            />
          </Grid>
          <Grid item xs={12}>
            <InputBrand control={control} controlName="product_brand_id" />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="product_type_name"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Nama Tipe Produk"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="unit_type"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Satuan Produk"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="wholesale_price"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Money
                  label="Harga Grosir"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="buying_price"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Money
                  label="Harga Beli"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="price"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Money
                  label="Harga"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="stock"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Money
                  label="Stock"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="has_tax"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  label="Pajak"
                  options={[
                    { text: "Ya", value: 1 },
                    { text: "Tidak", value: -1 },
                  ]}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="skip_stock"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  label="Tanpa Pengecekan Stock"
                  options={[
                    { text: "Ya", value: 1 },
                    { text: "Tidak", value: 0 },
                  ]}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
            <LoadingButton
              isLoading={loadingAddProduct}
              type="submit"
              text="Tambah"
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
